import React from "react";
import { Box } from "@chakra-ui/react";
import MySandbox from "../sandbox/MySandbox";
import Navbar from "../components/Navbar";

const SandboxPage = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <MySandbox />
            </Box>
        </Box>
    );
};

export default SandboxPage;